import(/* webpackMode: "eager", webpackExports: ["SearchHero"] */ "/app/next/src/components/search/hero.tsx");
